// One place that decides how money looks.
//
// Every screen used to print a dollar sign in front of a number, in 87 places. The numbers were never
// dollars - Tan Star buys in Chinese Yuan, which is what Mission Control's Financials has always reported
// them as - so the sign was simply wrong, and with a second business it would have been wrong in a second
// way. The currency belongs to the shop (migration 004), and this reads it from the signed-in session, so
// nothing has to thread it through the screens.
//
// It formats, it never converts. A price stored as 12.5 is 12.5 in whatever the shop's currency is.
import { getShopCurrency } from './session';

// The symbol each currency prints. A code with no symbol here falls back to the code itself followed by a
// space, which is ugly but honest - better than printing the wrong symbol. Migration 004 checks a shop's
// currency against this same list.
const SYMBOLS = {
  CNY: '¥', USD: '$', CAD: '$', EUR: '€', GBP: '£',
  HKD: 'HK$', JPY: '¥', AUD: '$', SGD: 'S$', TWD: 'NT$',
};

export const currencySymbol = (code) => SYMBOLS[code] || (code ? code + ' ' : '');

// The shop's money, formatted the way these screens have always formatted it: two decimals, no grouping,
// so the only thing this change alters is the symbol in front.
// Nothing at all for a missing value, which is what the screens did before: several of them read a price
// with optional chaining (`q.price?.toFixed(2)`), so a quote without one printed nothing rather than a
// zero. A real zero still prints as a zero.
export function money(value, code) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return '';
  return currencySymbol(code || getShopCurrency()) + n.toFixed(2);
}

// For the print views, which build their HTML as a string before the page exists. Same output.
export const moneyIn = (code) => (value) => money(value, code);
